import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";

import ObserverContext from "../../context/Observer";

import Menu from "../Menu/Menu";
import Logo from "../../assets/images/static/Logo.svg";
import { useTranslation } from "react-i18next";

import { MenuIcon } from "../../components/icons/index";

const Header = ({ language }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { elementInview } = useContext(ObserverContext);

  const { t } = useTranslation();

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
    console.log("handleMenuClick");
  };

  return (
    <>
      <header className={elementInview ? "header isVisible" : "header"}>
        <div className="header__content">
          <span></span>

          <Link
            to={`${t("routes.home")}`}
            className="header__content__logo"
          >
            <img loading="auto" src={Logo} alt="Tower Sports" />
          </Link>

          <div className="header__content__menu">
            <p>Menu</p>
            <MenuIcon
              setIsMenuOpen={setIsMenuOpen}
              isMenuOpen={isMenuOpen}
              handleMenuClick={handleMenuClick}
            />
          </div>
        </div>
      </header>
      <Menu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        handleMenuClick={handleMenuClick}
        elementInview={elementInview}
      />
    </>
  );
};

export default Header;
